import React from 'react';
import PropTypes from 'prop-types';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import {FormattedNumber} from 'react-intl';
import {ListItem} from 'material-ui/List';
import {lightBlue100} from 'material-ui/styles/colors';

class JustAskListItem extends React.Component {

    constructor(props) {
        super(props);

        this.onSelectChange = this
            .onSelectChange
            .bind(this);
    }


    onSelectChange(e) {

        const {justAsk, justAskActions, orderId} = this.props;

        justAskActions.justAskQuantitySet(justAsk.get('transactionTypeId'), e.target.value, orderId);
    }

    render() {

        const {justAsk, disabled} = this.props;
        if (!justAsk) {
            return null;
        }
        const rowStyle = {},
            messageStyle = {
                padding: '10px'
            };

        let errorDisplay = null,
            refreshIndicator = null;

        if (justAsk.get('hasUnsavedChanges')) {
            rowStyle.backgroundColor = lightBlue100;
        }

        if (justAsk.get('error')) {
            errorDisplay = (
                <div style={messageStyle} className="red lighten-1 white-text">{justAsk.get('error')}</div>
            );
        }

        if (justAsk.get('loading')) {
            refreshIndicator = (<RefreshIndicator
                size={40}
                left={0}
                top={0}
                status="loading"
                style={{
                display: 'inline-block',
                position: 'relative'
            }}/>);
        }

        const commisionDisplay = (
            <span><br/><FormattedNumber
                value={justAsk.get('commision')}
                style="currency"
                currency="USD"/></span>
        );

        const maxQuantity = 5;
        const options = [];
        for (let index = 0; index < maxQuantity + 1; index++) {
            options.push(
                <option key={'qty_option_' + index} value={index}>
                    {index}
                </option>
            );
        }        
        
        const select = (
            <select
                disabled={disabled}
                className="browser-default"
                style={{
                fontSize: '18px'
            }}
                onChange={this.onSelectChange}
                value={justAsk.get('quantity')}>
                {options}
            </select>
        );
        
        const primaryText = (
            <span>
                {justAsk.get('transactionType')}
                {errorDisplay}
                {refreshIndicator}
            </span>
        );

        return (<ListItem
            disabled={disabled}
            primaryText={primaryText}
            rightToggle={select}
            secondaryText={commisionDisplay}/>);
    }
}

JustAskListItem.propTypes = {
    justAsk: PropTypes.object,
    justAskActions: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool

};
export default JustAskListItem;
//force a move


// WEBPACK FOOTER //
// ./src/components/just-ask/JustAskListItem.js